import styled from 'styled-components';

import { Typography } from '@speeki/global-ui-components';

import { maxWidth } from '@utils/helpers';

export const CompanyPoliciesWrapper = styled.div`
    align-items: center;
    display: flex;
    flex-direction: column;
    padding: 56px 0;

    ${maxWidth('md')} {
        margin: 0 auto;
        max-width: 790px;
    }
`;

export const CompanyPoliciesTitle = styled(Typography.TextH2_28_44)`
    margin-bottom: 16px;
    text-align: center;
`;

export const CompanyPoliciesContent = styled.div`
    max-width: 100%;
    overflow-wrap: anywhere;

    /* The WYSIWYG editor (Quill) stores blank lines as empty <p></p>. Without
       content they collapse to zero height here, so author-entered blank lines
       disappear on the portal. Give empty paragraphs a line's height so the
       spacing matches the editor. */
    p:empty::before {
        content: '\\00a0';
    }

    img {
        height: auto;
        max-width: 100%;
    }

    iframe,
    video {
        max-width: 100%;
    }

    table {
        display: block;
        max-width: 100%;
        overflow-x: auto;
    }
`;

export const MobileCompanyPoliciesContent = styled.div`
    margin-top: 16px;

    /* Keep author-entered blank lines visible (empty <p></p> would collapse). */
    p:empty::before {
        content: '\\00a0';
    }
`;
